define([
    'core/urls',
    'moment',
    'components/datatable',
    'components/daterangepicker',
    'root/static/js/components/selectize',
    ],

    function (urls, moment, datatable, drp) {  
        return {
            init: function () {
                let root = "#reactions"; 

                let populateMetrics = (data) => {
                    let csatScore = document.querySelector("#csat_score");
                    let reviewCount = document.querySelector("#review_count");
                    let positiveCount = document.querySelector("#positive_count");
                    let neutralCount = document.querySelector("#neutral_count");
                    let negativeCount = document.querySelector("#negative_count");
                    let responseRate = document.querySelector("#response_rate");
                    let surveysViewed = document.querySelector("#surveys_viewed");
                    let surveysRated = document.querySelector("#surveys_rated");

                    if(Object.keys(data).length) {
                        csatScore.innerText = data.net_csat_score ? Math.round(data.net_csat_score * 10) / 10 : 0;
                        reviewCount.innerText = data.positive + data.negative + data.neutral;
                        positiveCount.innerText = data.positive;
                        neutralCount.innerText = data.neutral;
                        negativeCount.innerText = data.negative;
                        responseRate.innerText = Math.round(data.response_rate * 10) / 10;
                        surveysViewed.innerText = data.total;
                        surveysRated.innerText = data.answered;
                    }
                }

                let createRowCallback = (row, data, index) => {
                    
                    return new Promise((resolve, reject) => {
                        if(data.comment) {
                            var rowObj = this.reactions.row(index);
    
                            let reaction_class = '';                        
                            if (data.sentiment == 1) {
                                reaction_class = 'csat-reaction-type-positive';
                            } else if (data.sentiment == 0) {
                                reaction_class = 'csat-reaction-type-neutral';
                            } else if (data.sentiment == -1) {
                                reaction_class = 'csat-reaction-type-negative';
                            }
    
                            let updatedRow = row;
                            
                            let tr = document.createElement("tr");
                            tr.classList.add("comment-row");
                            let comment = `<div class="csat-reaction-child-comment"><p>${data.comment}</p></div><a href="#" style="display:none;" class="ml-2 less-more">more</a>`;
                            
                            tr.innerHTML = `<td colspan='6'><div class="csat-reaction-child ${reaction_class}">${comment}</div></td>`;
    
                            tr.querySelector(".less-more").addEventListener("click", (event) => {
                                event.preventDefault();
                                let btn = $(event.target);
                                if(btn.text() == 'more') {
                                    btn.parent().find('.csat-reaction-child-comment p').css('height', 'auto');
                                    btn.parent().find('.csat-reaction-child-comment p').css('white-space', 'normal');
                                    btn.text('less');
                                } else {
                                    btn.parent().find('.csat-reaction-child-comment p').css('white-space', 'nowrap');
                                    btn.parent().find('.csat-reaction-child-comment p').css('height', 21);
                                    btn.text('more');
                                }
                            })
                            
                            rowObj.child(tr).show();
                        }

                        resolve();
                    });
                }

                let resizeHandler = () => {
                    let comments = $('.csat-reaction-child-comment p');
                
                    comments.each(function () {
                        let btn = $(this).parent().parent().find('.less-more');
                        if (this.scrollWidth > this.offsetWidth){
                            btn.show();
                        } else if ($(this).css('white-space') != 'normal'){
                            btn.hide();
                        }
                    });
                }

                let columns = [
                    {
                        title: 'Rating',
                        width: '70px',
                        className: 'column-sentiment',
                        data: 'sentiment',
                        render: {
                            _: function(data) {
                                return globals.getSentimentLabel(data);
                            },
                            display: function(data) {
                                var sentiment_image = '<div class="image-wrapper"><img src="' + globals.getSentimentImageUrl(data) + '" alt="' + globals.getSentimentLabel(data) + '" height="30" width="30"/></div>';
                                return sentiment_image;
                            },
                            sort: null
                        }
                    },
                    {
                        title: 'Date',
                        className: 'column-date',
                        data: 'timestamp',
                        width: '110px',
                        render: {
                            _: 'formatted',
                            sort: 'iso8601',
                            exportPrint: 'formatted',
                            exportTabular: function(data) {return moment(data.iso8601).format('YYYY-MM-DD HH:mm:ss');},
                            display: function(data) {return moment(data.iso8601).format('DD MMM YYYY');}
                        }
                    },
                    {
                        title: 'Ticket',
                        className: 'column-ticket',
                        data: 'ticket',
                        render: {
                            _: 'id',
                            display: function(data) {
                                return data.link != null ? `<a target="_blank" href="${data.link}">${data.id}</a><br>${data.title}` : `${data.id}<br>${data.title}`;
                            },
                        }
                    },
                    {
                        title: 'Company',
                        className: 'column-company',
                        data: 'company',
                        render: {
                            _: 'name',
                            display: function(data) {return data.link != null ? '<a target="_blank" href="' + data.link + '">' + data.name + '</a>' : data.name;}
                        }
                    },
                    {
                        title: 'Contact',
                        className: 'column-contact',
                        data: 'contact',
                        render: {
                            _: 'name',
                            display: function(data) {return data.link != null ? '<a target="_blank" href="' + data.link + '">' + data.name + '</a>' : data.name;}
                        }
                    },
                    {
                        title: 'Agents',
                        className: 'column-resources',
                        data: 'agents',
                        render: {
                            _: null,
                            display: function(data) {return data.join(", ");}
                        }
                    },
                ];
        
                this.reactions = datatable.create(root, {
                    language: {
                        emptyTable: 'No reviews yet',
                        zeroRecords: 'No results found with current filters.',
                        infoFiltered: '',
                        searchPlaceholder: "Search",
                        search: "",
                        lengthMenu: "Results per page: _MENU_",
                        paginate: {
                            previous: "Prev",
                            next: "Next",
                        },  
                    },
                    columns: columns,
                    rowId: 'row_id',
                    order: [[1, 'desc']],
                    ajax: {
                        url: urls['csat:review-data'](),
                        contentType: "application/json",
                        type: "POST",
                        dataSrc:"reactions",
                        data: (d) => {
                            var options = {
                                format: {
                                    input: 'DD.MM.YYYY'
                                },
                                days_array: ['S', 'M', 'T', 'W', 'T', 'F', 'S']
                            };

                            drp.create(options, function () {});

                            d.filters = {};
                            d.filters['start_date'] = drp.getStartDate().format("YYYY-MM-DD");
                            d.filters['end_date'] = drp.getEndDate().format("YYYY-MM-DD");

                            return JSON.stringify(d);
                        },
                    },
                    lengthMenu: [ 10, 25, 50, 100],
                    serverSide: true,
                    createdRow: (row, data, index) => {
                        createRowCallback(row, data, index)
                        .then((val) => {
                            resizeHandler();
                        });
                    },
                    initComplete: (settings, data) => {

                        populateMetrics(data.metrics);
        
                        //add icon to search filter bar
                        let imageHtml = document.createElement("IMG");
                        imageHtml.src = "/static/icons/ic-search.svg";
                        let searchBar = document.querySelector(".dt-search");
        
                        searchBar.append(imageHtml);
        
                    },
                    stateSave: false,
                    dom: 'lfBr<"table-wrapper"t><"table-controls-bottom"p>',
                });        
            }
        }
    }
);